import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=c0634a8a&scoped=true&lang=pug&"
import script from "./Landing.vue?vue&type=script&lang=ts&"
export * from "./Landing.vue?vue&type=script&lang=ts&"
import style0 from "./Landing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Landing.vue?vue&type=style&index=1&id=c0634a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0634a8a",
  null
  
)

export default component.exports